(function () {
	const initAsideMenu = () => {
		const asideMenu = document.querySelector('.aside-menu');
		const asideMenuOverlay = document.querySelector('.aside-menu__overlay');
		const openAsideMenuButtons = document.querySelectorAll(
			'.aside-menu__toggle--open-btn',
		);

		if (!asideMenu || !asideMenuOverlay || openAsideMenuButtons.length === 0) {
			return;
		}

		const stickyHeader =
			document.querySelector('sticky-header') ||
			document.querySelector('.header-wrapper');
		const asideMenuWrapper = asideMenu.querySelector('.aside-menu__wrapper');
		const navigationLinks = asideMenu.querySelectorAll('a[href]');
		let lastTrigger = null;

		if (!asideMenu.id) {
			asideMenu.id = 'AsideMenu';
		}

		const setButtonState = (isOpen) => {
			openAsideMenuButtons.forEach((button) => {
				button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
				button.setAttribute('aria-controls', asideMenu.id);
			});
		};

		const openAsideMenu = (event) => {
			if (event) {
				event.preventDefault();
				lastTrigger = event.currentTarget;
			}

			if (stickyHeader) {
				stickyHeader.preventHide = true;
			}

			asideMenu.classList.add('aside-menu--open');
			asideMenuOverlay.classList.add('aside-menu__overlay--active');
			document.body.classList.add('overflow-hidden-drawer');
			setButtonState(true);

			window.requestAnimationFrame(() => {
				if (asideMenuWrapper) {
					asideMenuWrapper.focus();
				}
			});
		};

		const closeAsideMenu = (returnFocus = true) => {
			asideMenu.classList.remove('aside-menu--open');
			asideMenuOverlay.classList.remove('aside-menu__overlay--active');
			document.body.classList.remove('overflow-hidden-drawer');
			setButtonState(false);

			if (stickyHeader) {
				stickyHeader.preventHide = false;
			}

			if (returnFocus && lastTrigger) {
				lastTrigger.focus();
			}
		};

		const toggleAsideMenu = (event) => {
			if (asideMenu.classList.contains('aside-menu--open')) {
				event.preventDefault();
				closeAsideMenu();
				return;
			}

			openAsideMenu(event);
		};

		openAsideMenuButtons.forEach((button) => {
			if (button.dataset.asideMenuInitialized === 'true') {
				return;
			}

			button.dataset.asideMenuInitialized = 'true';
			button.setAttribute('aria-expanded', 'false');
			button.addEventListener('click', toggleAsideMenu);
		});

		if (asideMenuOverlay.dataset.asideMenuInitialized !== 'true') {
			asideMenuOverlay.dataset.asideMenuInitialized = 'true';
			asideMenuOverlay.addEventListener('click', () =>
				closeAsideMenu(false),
			);
		}

		navigationLinks.forEach((link) => {
			if (link.dataset.asideMenuInitialized === 'true') {
				return;
			}

			link.dataset.asideMenuInitialized = 'true';
			link.addEventListener('click', () => closeAsideMenu(false));
		});

		if (
			document.documentElement.dataset.asideMenuKeyboardInitialized !==
			'true'
		) {
			document.documentElement.dataset.asideMenuKeyboardInitialized = 'true';

			document.addEventListener('keydown', (event) => {
				if (
					event.key === 'Escape' &&
					asideMenu.classList.contains('aside-menu--open')
				) {
					closeAsideMenu();
				}
			});
		}
	};

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAsideMenu);
	} else {
		initAsideMenu();
	}

	document.addEventListener('shopify:section:load', initAsideMenu);
})();